var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ButtonGroup"},_vm._l((_vm.buttons),function(button){return _c('button',{key:button.value,staticClass:"ButtonGroupButton",class:{ 'selected-option': button.value === _vm.selectedValue },on:{"click":function($event){return _vm.handleClick(button, _vm.selectedValue)}}},[_vm._v(" "+_vm._s(button.displayValue)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }